import { render, staticRenderFns } from "./ProgramList.vue?vue&type=template&id=985b6bfc&scoped=true&"
import script from "./ProgramList.vue?vue&type=script&lang=js&"
export * from "./ProgramList.vue?vue&type=script&lang=js&"
import style0 from "./ProgramList.vue?vue&type=style&index=0&id=985b6bfc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985b6bfc",
  null
  
)

export default component.exports